import "./AlertBlock.scss";

const AlertBlock: React.FC<{
  title: string;
  body: string | JSX.Element;
  isError?: boolean;
}> = (props) => {
  const { title, body, isError } = props;
  return (
    <>
      <div className="note-block bg-white ">
        <div className={`note-block_body w-100 ${isError && "note-block_error"}`}>
          <h2>{title}</h2>
          {typeof body === "string" ? <p>{body}</p> : body}
        </div>
      </div>
    </>
  );
};

export default AlertBlock;
